export const message = {
  forbidden: 'アクセスが拒否されました。',
  internalServerError:
    'ネットワークに接続できません。接続を確認して、もう一度お試しください。',
  loginFalse: 'ユーザー名またはパスワードが正しくありません。',
  loginSessionExpired: 'ログインセッションの有効期限が切れました。',
  confirmDelete: 'このユーザーを削除してもよろしいですか？',
  required: 'この項目は必須です！',
  createSuccess: 'データの登録が完了しました。',
  updateSuccess: 'データの更新が完了しました。',
  deleteSuccess: 'データを削除しました。',
  passwordNotEqual: '入力したパスワードが一致しません。',
  notRecord: 'レコードがありません。',
  notFound: 'リクエストが見つかりません。',
  confirmLogout: 'ログアウトしてもよろしいですか？',
  passwordMismatchMessage: 'パスワードと確認用パスワードが一致しません。',
  passwordLoginIdRequired: 'ログインIDとパスワードの両方を入力してください。',
  passwordRequired: 'パスワードを入力してください。',
  passwordConfirmRequired: 'パスワード（確認）を入力してください。',
  passwordMinLength: 'パスワードは8文字以上で入力してください。',
  passwordPattern:
    'パスワードは8文字以上で、大文字・小文字・数字を含めてください。',
  currentPasswordRequired: '現在のパスワードを入力してください。',
  loginIdPattern: 'ログインIDは4～20文字の半角英数字で入力してください。',
  loginIdRequired: 'ログインIDを入力してください。',
  nameRequired: '名前を入力してください。',
  companyRequired: '担当事業者を選択してください。',
  storeRequired: '担当店舗を選択してください。',
  dataNotfound: '該当するデータがありません。',
  titleConfirm: '削除確認',
  changePasswordSuccess: 'パスワードの変更が完了しました。',
  titleLogout: 'ログアウト確認',
  marchineNotFound: '号機を選択してください。',
  unauthorized: 'URLの有効期限が切れています。手続きを再度お願い致します。',
  storesWithoutMachines: 'この店舗には券売機が設置されていません。',
  noteLength: 'メモは500文字以内で入力してください。',
  exportFailed:
    'エクスポート中にエラーが発生しました。しばらくしてから再度お試しください。',
  exportTimeout:
    'データ量が多すぎます。検索条件を絞り込んで再度お試しください。',
};
